<script setup>
import { ref, computed, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useCarEventsSubsStore } from '@/stores/car-events-subs'

const props = defineProps({
    carUuid: {
        type: String,
        required: true
    }
})

const translaterStore   = useTranslaterStore()
const carEventsSubsStore = useCarEventsSubsStore()

const carEvents = ref({
    engine_on: {
        title: 'EVENT_ENGINE_ON',
        requireAreas: false,
        subscribed: false
    },
    // remote_engine_on: {
    //     title: 'EVENT_REMOTE_ENGINE_ON',
    //     requireAreas: false,
    //     subscribed: false
    // },
    engine_off: {
        title: 'EVENT_ENGINE_OFF',
        requireAreas: false,
        subscribed: false
    },
    // decrease_mileage: {
    //     title: 'EVENT_DECREASE_MILEAGE',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // protected_area_in: {
    //     title: 'EVENT_PROTECTED_AREA_IN',
    //     requireAreas: true,
    //     subscribed: false
    // },
    // protected_area: {
    //     title: 'EVENT_PROTECTED_AREA',
    //     requireAreas: true,
    //     subscribed: false
    // },
    // unlocked: {
    //     title: 'EVENT_UNLOCKED',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // locked: {
    //     title: 'EVENT_LOCKED',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // cmd_engine_on: {
    //     title: 'EVENT_CMD_ENGINE_ON',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // cmd_engine_off: {
    //     title: 'EVENT_CMD_ENGINE_OFF',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // cmd_unlock: {
    //     title: 'EVENT_CMD_UNLOCK',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // cmd_lock: {
    //     title: 'EVENT_CMD_LOCK',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // cmd_trunk_open: {
    //     title: 'EVENT_CMD_TRUNK_OPEN',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // cmd_trunk_close: {
    //     title: 'EVENT_CMD_TRUNK_CLOSE',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // cmd_light: {
    //     title: 'EVENT_CMD_LIGHT',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // cmd_beep: {
    //     title: 'EVENT_CMD_BEEP',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // low_battery_voltage: {
    //     title: 'EVENT_LOW_BATTERY_VOLTAGE',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // alarm_system_triggered: {
    //     title: 'EVENT_ALARM_SYSTEM_TRIGGERED',
    //     requireAreas: false,
    //     subscribed: false
    // },
    // veh_unlocked_alert: {
    //     title: 'EVENT_VEH_UNLOCKED_ALERT',
    //     requireAreas: false,
    //     subscribed: false
    // }
})

const eventsForSub = ref([])
const eventsSubsMsg = ref({})

const getTranslate = computed(() => translaterStore.getTranslate)
const carEventSubsMsg = computed(() => carEventsSubsStore.carEventSubsMsg)

function eventsSubsFormSubmit(event) {
    if (event.target.checked) {
        // @TODO: Это из API v2, которое уже заработало на бекенде
        let data = {
            carUuid: props.carUuid,
            types: [{ ptype: 'EMAIL', type: event.target.value }]
        }
        carEventsSubsStore.createCarEventsSubs(data)
    } else {
        // @TODO: Это из API v1, так как DELETE на бекенде только старый
        let data = {
            carUuid: props.carUuid,
            types: [event.target.value],
            ptype: 'EMAIL'
        }
        carEventsSubsStore.deleteCarEventsSubs(data)
    }
}

function updateEventsSubs(events) {
    events.map(event => {
        if (event.type in carEvents.value && event.ptype == 'EMAIL') {
            eventsForSub.value.push(event.type)
            carEvents.value[event.type].subscribed = true
        }
    })
}

carEventsSubsStore.readCarEventsSubs(props.carUuid).then(eventsSubs => {
    updateEventsSubs(eventsSubs.array || [])
})

watch(carEventSubsMsg, msg => {
    eventsSubsMsg.value = msg
})
</script>

<template>

    <div class="uta-car-events-subs">

        <div
            v-if="'success' in eventsSubsMsg"
            class="mb-3 uta-alert"
            :class="{
                'uta-alert--success': eventsSubsMsg.success,
                'uta-alert--danger': !eventsSubsMsg.success
            }"
        >
            <span class="material-icons uta-alert__icon">
                {{ eventsSubsMsg.success ? 'check_circle_outline' : 'error_outline' }}
            </span>
            <div class="uta-alert__text">
                {{ getTranslate[eventsSubsMsg.text] || eventsSubsMsg.text }}
            </div>
            <button
                type="button"
                class="btn-close uta-alert__close"
                @click="carEventsSubsStore.eventsSubsMsg = {}"
            ></button>
        </div>

        <div class="uta-car-events-subs__descr">
            {{ getTranslate.EVENTS_SUBS_DESCR }}
        </div>

        <form class="uta-car-events-subs__events" action="" method="post">
            <div v-for="(event, index) of carEvents" :key="index" class="uta-car-events-subs__event">
                <div class="switcher switcher--dark">
                    <input
                        class="switcher__input"
                        type="checkbox"
                        :name="'event_subs_' + index"
                        :id="'event_subs_' + index"
                        :checked="event.subscribed"
                        :value="index"
                        @change="eventsSubsFormSubmit($event)"
                    />
                    <label class="switcher__label" :for="'event_subs_' + index">
                        <span class="switcher__text">{{ getTranslate[event.title] }}</span>
                    </label>
                </div>
            </div>
        </form>
    </div>

</template>

<style lang="scss">
@import '@/assets/styles/scss/components/car/car-events-subscribe.scss';
</style>